import { Business } from './capitalAccountClient';

export function isUsa(business: Business) {
  const primaryAddress = business.addresses.find(address => address.isPrimary);
  return primaryAddress?.countryCode === 'USA';
}

export function isMissingData(business: Business): boolean {
  if (business.signer.ownership === undefined || business.signer.ownership === null) {
    return true;
  }

  if (!isUsa(business)) {
    return false;
  }

  return !business.signer.ssn;
}